import React, { useContext } from "react";
import { Field } from "formik";
import { AuthContext } from "../../context/AuthContext";
interface FormikFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  placeholder?: string;
}
const EditorTextArea = ({
  name,
  label,
  placeholder,
  ...props
}: FormikFieldProps) => {
  const dataContext = useContext(AuthContext)

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div className="mb-4 poppins-regular">
      {label && (
        <label
          htmlFor={name}
          className={`${theme === 'dark' ? "text-black" : "text-white"} transition-all duration-500 block mb-2 text-sm font-medium font-montserrat`}
        >
          {label}
        </label>
      )}
        <Field
          id={name}
          name={name}
          as="textarea"
          placeholder={placeholder}
          className={`${theme === 'dark' ? "bg-white text-black" : "bg-transparent border-white/30"} transition-all duration-500 w-full px-4 py-3 h-32 border-b font-montserrat focus:ring-0 active:ring-0 focus:outline-none`}
          {...props}
        />
      </div>
  );
};
export default EditorTextArea;